import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getEvent, updateEvent } from "@/lib/api/clients/EventClient";
import { qk } from "@/lib/query/queryKeys";
import type { EventRowDTO } from "@/types/EventRowDTO";

const DETAIL_FIELDS =
  "eventId,companyId,name,start,end,timeZone,address,address2,zipCode,city,country,locationName,registrationType,additionalFields,plugins,archived,permanentlyArchived,countedGuests,globalGuestLimit";

export function useEvent(eventId: string | null, fields: string = DETAIL_FIELDS) {
  return useQuery({
    queryKey: eventId ? qk.events.detail(eventId, fields) : ["events", "detail", "none"],
    queryFn: () => getEvent(eventId!, fields),
    enabled: !!eventId,
    staleTime: 30_000,
  });
}

export function useUpdateEvent(eventId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (event: EventRowDTO) => updateEvent(eventId, event),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.events.all });
      qc.invalidateQueries({ queryKey: ["events", "detail", eventId] });
    },
  });
}
